module.exports = __webpack_public_path__ + "img/detail.dcea5b31.png";